export default function ArrowUp() {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.5L5 0.5L9 4.5"
        stroke="#1A1F1F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
